const list = [{
		img: require('@/assets/image/journalism/t-1.png'),
		name: "租户室内常见报修20问",
	},
	{
		img: require('@/assets/image/journalism/t-2.png'),
		name: "关于长春市人才公寓办公服务电话时间的通知",
	},
	{
		img: require('@/assets/image/journalism/t-3.png'),
		name: "租户室内常见报修20问",
	},
	{
		img: require('@/assets/image/journalism/t-4.png'),
		name: "租户室内常见报修20问",
	},
]

const problem = [{
		name: "退租时费用如何结算？",
		content: "A；人才公寓公司根据承租人退租时的退款项和扣款项与承租人进行结算，结算金额=退款项-扣款项。时的退款项和扣款项与承租人进行结算，结算金额=退款项-扣款项",
		state: false
	},
	{
		name: "人才公寓房屋最长可租多少年？",
		content: "",
		state: false
	},
	{
		name: "如何申请入住人才公寓？",
		content: "",
		state: false
	},
	{
		name: "曾经住过人才公寓房，因故离开我市后如再回我市工作，还能再申请人才公寓房吗？",
		content: "",
		state: false
	},
	{
		name: "合同期内在我市工作变动还能居住人才公寓吗？该办理什么手续？",
		content: "",
		state: false
	},
	{
		name: "人才公寓房内是否可以留宿亲戚朋友？",
		content: "",
		state: false
	},
	{
		name: "如何申请入住人才公寓？",
		content: "",
		state: false
	}
]

export {
	list,
	problem
}
